<script>
import Languages from "../../lang/lang";

export default {
  name: "Farms",
  props: ['farms'],
  computed: {
    lang() {
      return Languages.texts('farms');
    },
    currentLang() {
      return window['CURRENT_LANGUAGE'];
    }
  }
}
</script>

<template>
  <div class="farms">
    <div class="block-title">
      {{ lang['title'] }}
    </div>
    <div class="farm-list scroll-items">
      <div class="farm" v-for="farm in farms" :data-farm-id="farm.id">
        <div class="image" style="--image: url('/assets/images/offer-devices/antminer-s19.png')">
          <h2 class="farm-name">{{ farm.title }}</h2>
        </div>
        <div class="farm-contents">

          <div class="farm-details">
            <div class="item-title">
              {{ lang['share'] }}:
            </div>
            <div class="item-value gold-gradient">
              <span>{{ Math.round(farm.share * 100 * 100000) / 100000 }}%</span>
            </div>
            <div class="item-title">
              {{ lang['yesterday'] }}:
            </div>
            <div class="item-value gold-gradient">
              <span>{{ farm.yesterdayIncome }} BTC</span>
            </div>
            <div class="item-title">
              {{ lang['total'] }}:
            </div>
            <div class="item-value gold-gradient">
              <span>{{ farm.totalIncome }} BTC</span>
            </div>
          </div>
          <router-link class="btn btn-simple" :to="'/farm/' + farm.id">
            {{ lang['view'] }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>